export const dropdownItems = [
  'anchor catcher',
  'bent sub',
  'blast joint',
  'blind pipe',
  'bridge plug',
  'casing brush',
  'casing cutter closed',
  'casing cutter open',
  'casing',
  'cement plug',
  'cement',
  'chemical injection mandrel',
  'choke',
  'circulating sleeve',
  'circulating string',
  'corod',
  'crossover enlarging',
  'crossover reducing',
  'crossover',
  'cuttings',
  'default',
  'downhole choke',
  'drill collar',
  'drill pipe',
  'dual tubing hanger',
  'electric submersible pump',
  'expandable sand screen',
  'expansion joint.2',
  'expansion joint',
  'external packer',
  'float sub',
  'flow coupling',
  'gas anchor',
  'gas lift dummy',
  'gas lift mandrel',
  'gravel pack crossover',
  'gravel pack extension',
  'gravel pack screen',
  'heavy weight drill pipe',
  'hole opener',
  'holefill',
  'hydraulic packer',
  'jar',
  'jet pump',
  'landing collar',
  'landing nipple',
  'liner hanger',
  'liner',
  'locator sub',
  'mandrel',
  'mud motor',
  'mule shoe',
  'nipple',
  'nogo nipple',
  'on-off tool',
  'open hole',
  'packer dual',
  'packer.blue',
  'packer',
  'pdc drill bit',
  'perforated liner',
  'perforated tubing.2',
  'perforated tubing',
  'perforating guns',
  'perforation',
  'plug',
  'polished nipple',
  'polished rod',
  'pony rod',
  'port collar',
  'production packer',
  'profile nipple',
  'progressive cavity pump',
  'pump barrel',
  'pump',
  'pup joint',
  'reamer',
  'reentry guide',
  'rod pump.2',
  'rod pump',
  'rod.green',
  'safety valve closed',
  'safety valve open',
  'sand control screen',
  'scssv 1 sub',
  'scssvsub',
  'seal assembly.2',
  'seal assembly',
  'seal bore receptacle',
  'seating nipple',
  'shear tool',
  'side pocket mandrel.2',
  'side pocket mandrel',
  'sinker bar',
  'sliding sleeve.2',
  'sliding sleeve',
  'slotted liner',
  'spiral drill collar',
  'ssv closed',
  'ssv open',
  'stabilizer',
  'subsurface safety valve closed',
  'subsurface safety valve open',
  'sucker rod pump.cutaway',
  'sucker rod pump',
  'sucker rod',
  'tail joint',
  'tail pipe',
  'tool',
  'tricone drill bit',
  'tubing anchor',
  'tubing hanger',
  'tubing.gold',
  'tubing.green',
  'tubing.grey',
  'tubing.red',
  'tubing',
  'valve closed',
  'valve open',
  'valve',
  'wellhead',
  'wireline guide.2',
  'wireline guide',
  'yblock',
  'extras/crossover.grey',
  'extras/drill bit.1',
  'extras/drill bit.2',
  'extras/drill bit.3',
  'extras/drill bit.4',
  'extras/gas lift mandrel.grey',
  'extras/hole opener.1',
  'extras/hole opener.2',
  'extras/hole opener.3',
  'extras/reamer.1',
  'extras/reamer.2',
  'extras/reamer.3',
  'extras/tricone drill bit.grey',
  'deprecated/cement_w_gradient',
  'deprecated/drill bit.2',
  'deprecated/drill bit.3',
  'deprecated/float collar',
  'deprecated/hollowareafill',
  'deprecated/jet pump.ORIGINAL',
  'deprecated/liner slotted',
  'deprecated/liner',
  'deprecated/mule shoe.2',
  'deprecated/mule shoe',
  'deprecated/old_perf',
  'deprecated/perforation',
  'deprecated/pump barrel.ORIGINAL',
  'deprecated/rod pump',
  'deprecated/sliding sleeve.2.ORIGINAL',
  'deprecated/spiral drill collar',
  'deprecated/sq',
  'deprecated/ssv closed',
  'deprecated/ssv open',
  'deprecated/tricone drill bit.old',
  'deprecated/tub_valid',
  'animated/drill bit',
  'animated/spiral drill collar',
];

export const formID = 'Schematic_Form_1';

export const SCHEMATIC_FORM_VALUES = {
  COMPONENT: 'component',
  DESCRIPTION: 'description',
  START_DEPTH: 'startDepth',
  END_DEPTH: 'endDepth',
  INNER_DIAMETER: 'innerDiameter',
  OUTER_DIAMETER: 'outerDiameter',
};

export const SCHEMATIC_COMMENT_FORM_VALUES = {
  COMMENT: 'comment',
};

export const SCHEMATIC_VERSION_FORM_VALUES = {
  VERSION: 'version',
};
